import { render, staticRenderFns } from "./privatnost.vue?vue&type=template&id=24cdb493&"
import script from "./privatnost.vue?vue&type=script&lang=js&"
export * from "./privatnost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports